/* eslint-disable prefer-promise-reject-errors */
import { axios } from '@carvana/purchase-utils';

export const fetchDashboard = () => {
  return axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/dashboard`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));
};

export const fetchOrderSummary = () => {
  return axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/dashboard/summary`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));
};

export const fetchOPDNotifications = () => {
  return axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/opdnotification`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));
};

export const getUsersExperiments = userId => {
  return axios
    .get(
      `${process.env.SPLITTEST_API_URL}/api/v2/identifier/profile?IdentifierType=CarvanaUserId&Identifier=${userId}`
    )
    .then(res => res.data)
    .catch(() => {});
};

export const getVehicleSoldOnLotById = stockNumber =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/vehicle/vehiclesoldonlot/${stockNumber}`
  }).then(res => res.data);

export const getPaymentSummary = async () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v2/paymentcollection/summary/orderplaced`
  })
    .then(res => res.data)
    .catch(() => {});
